// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"d08f3cac","924":"f6eb0f13"}[chunkId] + ".chunk.js";
};